<template><!-- svgo-optimised -->
<svg class="icon icon__search" width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M7 13C10.3137 13 13 10.3137 13 7C13 3.68629 10.3137 1 7 1C3.68629 1 1 3.68629 1 7C1 10.3137 3.68629 13 7 13Z" stroke="currentColor" stroke-miterlimit="10"/>
  <path d="M13 16L10 12" stroke="currentColor" stroke-miterlimit="10"/>
</svg>

</template>